// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"41dcc1bc7ed02719856a","655":"31cdb7b3520572ac6df1"}[chunkId] + ".js";
};